import { useState } from 'react';
import API from '../api';


const s = {
  page: { minHeight: '100vh', backgroundColor: '#f5f5f3', fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif' },
  topNav: { backgroundColor: '#fff', borderBottom: '0.5px solid #e8e8e8', padding: '0 32px', height: '56px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  navBrand: { fontSize: '15px', fontWeight: '700', color: '#1a1a1a', letterSpacing: '-0.3px' },
  navRight: { display: 'flex', alignItems: 'center', gap: '20px' },
  navLink: { fontSize: '13px', color: '#666', textDecoration: 'none', background: 'none', border: 'none', cursor: 'pointer', padding: 0 },
  subNav: { backgroundColor: '#fff', borderBottom: '0.5px solid #e8e8e8', padding: '0 32px', display: 'flex' },
  subNavBtn: { padding: '12px 16px', border: 'none', borderBottom: '2px solid transparent', backgroundColor: 'transparent', fontSize: '13px', color: '#aaa', cursor: 'pointer', fontWeight: '500' },
  subNavBtnActive: { color: '#1a1a1a', borderBottomColor: '#1a1a1a' },
  content: { maxWidth: '700px', margin: '0 auto', padding: '32px 24px' },
  card: { backgroundColor: '#fff', border: '0.5px solid #e8e8e8', borderRadius: '8px', padding: '24px', marginBottom: '16px' },
  cardTitle: { fontSize: '15px', fontWeight: '600', color: '#1a1a1a', marginBottom: '16px' },
  infoRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '0.5px solid #f5f5f5', fontSize: '13px' },
  infoLabel: { color: '#aaa', fontWeight: '500' },
  infoValue: { color: '#1a1a1a' },
  dangerCard: { backgroundColor: '#fff', border: '0.5px solid #f5c6c6', borderRadius: '8px', padding: '24px' },
  dangerTitle: { fontSize: '15px', fontWeight: '600', color: '#c0392b', marginBottom: '8px' },
  dangerBody: { fontSize: '13px', color: '#888', lineHeight: 1.6, marginBottom: '16px' },
  dangerBtn: { padding: '9px 18px', backgroundColor: '#c0392b', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: '500', cursor: 'pointer' },
  dangerBtnDisabled: { padding: '9px 18px', backgroundColor: '#ccc', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: '500' },
  cancelBtn: { padding: '9px 18px', backgroundColor: '#fff', color: '#666', border: '0.5px solid #e0e0e0', borderRadius: '6px', fontSize: '13px', cursor: 'pointer' },
  confirmPrompt: { fontSize: '13px', color: '#444', marginBottom: '10px' },
  error: { backgroundColor: '#fdecea', color: '#c0392b', padding: '10px 14px', borderRadius: '6px', marginBottom: '12px', fontSize: '13px' },
  input: { width: '100%', padding: '9px 12px', border: '0.5px solid #e0e0e0', borderRadius: '6px', fontSize: '13px', outline: 'none', color: '#1a1a1a', boxSizing: 'border-box', marginBottom: '12px' },
  confirmBtns: { display: 'flex', gap: '10px' },
};

function Settings({ onBack, onNavigate }) {
  const restaurant = JSON.parse(localStorage.getItem('restaurant') || '{}');
  const [confirming, setConfirming] = useState(false);
  const [confirmText, setConfirmText] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleDeactivate = async () => {
    if (confirmText !== 'DEACTIVATE') { setError('Please type DEACTIVATE to confirm'); return; }
    setLoading(true);
    setError('');
    try {
      const token = localStorage.getItem('token');
      await API.patch('/restaurant/deactivate', {});
      localStorage.removeItem('token');
      localStorage.removeItem('restaurant');
      window.location.href = '/?deactivated=1';
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to deactivate account');
      setLoading(false);
    }
  };

  const handleLogout = () => { localStorage.removeItem('token'); localStorage.removeItem('restaurant'); window.location.href = '/'; };

  const nav = (tab) => { if (onNavigate) onNavigate(tab); else onBack(); };

  return (
    <div style={s.page}>
      <div style={s.topNav}>
        <span style={s.navBrand}>{restaurant.name || 'Menu Board'}</span>
        <div style={s.navRight}>
          <a href={'/menu/' + restaurant.slug} target="_blank" rel="noreferrer" style={s.navLink}>View menu</a>
          <button style={s.navLink} onClick={handleLogout}>Sign out</button>
        </div>
      </div>
            <div style={s.subNav}>
        <button style={{...s.subNavBtn, ...('menus' === 'settings' ? s.subNavBtnActive : {})}} onClick={() => nav('menus')}>Menus</button>
        <button style={{...s.subNavBtn, ...('hours' === 'settings' ? s.subNavBtnActive : {})}} onClick={() => nav('hours')}>Hours</button>
        <button style={{...s.subNavBtn, ...('profile' === 'settings' ? s.subNavBtnActive : {})}} onClick={() => nav('profile')}>Profile</button>
        <button style={{...s.subNavBtn, ...('staff' === 'settings' ? s.subNavBtnActive : {})}} onClick={() => nav('staff')}>Staff</button>
        <button style={{...s.subNavBtn, ...('settings' === 'settings' ? s.subNavBtnActive : {})}} onClick={() => nav('settings')}>Settings</button>
      </div>

      <div style={s.content}>
        <div style={s.card}>
          <h2 style={s.cardTitle}>Account Information</h2>
          <div style={s.infoRow}><span style={s.infoLabel}>Restaurant</span><span style={s.infoValue}>{restaurant.name}</span></div>
          <div style={s.infoRow}><span style={s.infoLabel}>Menu URL</span><span style={s.infoValue}>digitalmenu.ng/menu/{restaurant.slug}</span></div>
        </div>

        <div style={s.dangerCard}>
          <h2 style={s.dangerTitle}>Deactivate Account</h2>
          <p style={s.dangerBody}>Deactivating your account will immediately make your public menu unavailable. Your data is retained and you can contact us to reactivate.</p>

          {!confirming ? (
            <button style={s.dangerBtn} onClick={() => setConfirming(true)}>Deactivate Account</button>
          ) : (
            <div>
              <p style={s.confirmPrompt}>Type <strong>DEACTIVATE</strong> to confirm:</p>
              {error && <p style={s.error}>{error}</p>}
              <input style={s.input} type="text" placeholder="DEACTIVATE" value={confirmText} onChange={(e) => setConfirmText(e.target.value)} />
              <div style={s.confirmBtns}>
                <button style={loading ? s.dangerBtnDisabled : s.dangerBtn} onClick={handleDeactivate} disabled={loading}>
                  {loading ? 'Deactivating...' : 'Confirm Deactivation'}
                </button>
                <button style={s.cancelBtn} onClick={() => { setConfirming(false); setConfirmText(''); setError(''); }}>Cancel</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}


export default Settings;
